import { Group } from './group.js'
import { GroupQuery } from './group-query.js'
import { GroupMutation } from './group-mutation.js'

export const entities = [Group]
export const resolvers = [GroupQuery, GroupMutation]
